export default __webpack_public_path__ + "static/media/darkDrowsy.044e183e.png";